module.exports = __webpack_public_path__ + "sq13-09ab206b.png";